import Vue from 'vue';
import { colors } from '@/plugins/vuelux/util/colors';
import {
  Vuetify,
  VApp,
  VAlert,
  VCard,
  VChip,
  VNavigationDrawer,
  VCheckbox,
  VCarousel,
  VDivider,
  VFooter,
  VList,
  VBtn,
  VBtnToggle,
  VIcon,
  VGrid,
  VAvatar,
  VMenu,
  VTabs,
  VTextField,
  VToolbar,
  VJumbotron,
  VDialog,
  VProgressCircular,
  VImg,
  VPagination,
  VInput,
  VDataTable,
  VSnackbar,
  VProgressLinear,
  transitions
} from 'vuetify';
import 'vuetify/src/stylus/app.styl';
import { Ripple } from 'vuetify/es5/directives'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/custom-fonts/luxtag/css/fontello.css';

const CUSTOM_ICONS = {
  'hamburger': 'icon-hamburger',
  'claim': 'icon-claim-icon-btn',
  'receive': 'icon-receive-icon-btn',
  'transfer': 'icon-transfer-icon-btn',
  'verify': 'icon-verify-icon-btn',
  'attachment': 'icon-attachment',
  'avatar': 'icon-avatar',
  'switchCamera': 'icon-camera',
  'comment-oval': 'icon-comment-black-oval-bubble-shape',
  'list': 'icon-list',
  'path': 'icon-path-272',
  'pencil': 'icon-pencil-edit-button-1',
  'transfer1': 'icon-transfer-icon-btn-1',
  'share': 'icon-share'
}

Vue.use(Vuetify, {
  iconfont: 'fa',
  icons: CUSTOM_ICONS,
  components: {
    VApp,
    VAlert,
    VCard,
    VChip,
    VNavigationDrawer,
    VCheckbox,
    VCarousel,
    VDivider,
    VFooter,
    VList,
    VBtn,
    VBtnToggle,
    VIcon,
    VGrid,
    VAvatar,
    VMenu,
    VTabs,
    VToolbar,
    VTextField,
    VJumbotron,
    VDialog,
    VProgressCircular,
    VProgressLinear,
    VImg,
    VPagination,
    VInput,
    VDataTable,
    VSnackbar,
    transitions,
  },
  theme: {
    primary: colors.primary,
    secondary: colors.secondary,
    accent: colors.accent,
    error: colors.error,
    info: colors.info,
    success: colors.success,
    warning: colors.warning,
    lines: colors.lines,
  },
  directives: {
    Ripple
  }
})
